var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.urlType === 'detail')?_c('ViewPanel'):(_vm.urlType === 'list')?_c('PageList'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }